function isObject(item) {
  return typeof item === 'object' && !Array.isArray(item) && item !== null
}

export function getValueByKeyPath(item, keyPath) {
  const keys = keyPath.split('.')
  let cur = item
  for (const key of keys) {
    if (cur && cur[key]) {
      cur = cur[key]
    } else {
      console.warn(`Key '${keyPath}' not found in the object ${item}`)
      return undefined
    }
  }
  return cur
}

function getIndexesKey(indexKeys) {
  if (typeof indexKeys === 'string') {
    return [
      {
        keyPath: indexKeys,
        formatKey: indexKeys,
        formatKeyValue: v => String(v),
      },
    ]
  }

  if (isObject(indexKeys)) {
    return [
      {
        keyPath: indexKeys.key,
        formatKey: indexKeys.formatKey ? indexKeys.formatKey : indexKeys.key,
        formatKeyValue:
          typeof indexKeys.formatKeyValue === 'function'
            ? indexKeys.formatKeyValue
            : v => String(v),
      },
    ]
  }

  const formattedKeys = []
  if (Array.isArray(indexKeys)) {
    for (const indexKey of indexKeys) {
      if (typeof indexKey === 'string') {
        formattedKeys.push({
          keyPath: indexKeys,
          formatKey: indexKeys,
          formatKeyValue: v => String(v),
        })
      }
      if (isObject(indexKey)) {
        formattedKeys.push({
          keyPath: indexKey.key,
          formatKey: indexKey.formatKey ? indexKey.formatKey : indexKey.key,
          formatKeyValue:
            typeof indexKey.formatKeyValue === 'function'
              ? indexKey.formatKeyValue
              : v => String(v),
        })
      }
    }
  }

  return formattedKeys
}

export function indexBy(array, indexKey, options = {}) {
  if (!array || !array.length) return {}

  const indexesKey = getIndexesKey(indexKey)
  if (!indexesKey.length) return {}

  const indexedArray = {}
  for (const key of indexesKey) {
    indexedArray[key.formatKey] = {}
  }

  for (const item of array) {
    for (const key of indexesKey) {
      const valueOnKeyPath = getValueByKeyPath(item, key.keyPath)
      if (valueOnKeyPath === undefined) continue
      const keyValue = key.formatKeyValue(valueOnKeyPath)
      if (!indexedArray[key.formatKey][keyValue])
        indexedArray[key.formatKey][keyValue] = [item]
      else indexedArray[key.formatKey][keyValue].push(item)
    }
  }
  return indexedArray
}

export async function indexByAsync(array, indexKey, options = {}) {
  if (!array || !array.length) return {}

  const indexesKey = getIndexesKey(indexKey)
  if (!indexesKey.length) return {}

  const indexedArray = {}
  for (const key of indexesKey) {
    indexedArray[key.formatKey] = {}
  }

  let curIndex = 0
  const releaseControlAmount = options?.releaseControlAmount ?? 100

  for (const item of array) {
    curIndex++
    if (curIndex % releaseControlAmount === 0)
      await new Promise(resolve => setTimeout(resolve, 0))
    for (const key of indexesKey) {
      const keyValue = key.formatKeyValue(getValueByKeyPath(item, key.keyPath))
      if (!indexedArray[key.formatKey][keyValue])
        indexedArray[key.formatKey][keyValue] = [item]
      else indexedArray[key.formatKey][keyValue].push(item)
    }
  }
  return indexedArray
}
